module.exports = __webpack_public_path__ + "media/19-1.5a97a526.mp4";